var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8,
    ry: 0,
    style: {
      fill: "#000",
      strokeWidth: 11.8582,
      strokeMiterlimit: 4.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "DASH",
    style: {
      fontSize: "5.33333px",
      lineHeight: 1.25,
      fontFamily: "Neuropolitical",
      InkscapeFontSpecification: "Neuropolitical",
      letterSpacing: 0,
      wordSpacing: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.605 5.859V2.22h2.88q.406 0 .672.07.272.064.432.213.16.144.224.384.07.24.07.581v1.142q0 .346-.07.586-.064.235-.224.384-.16.144-.432.214-.266.064-.672.064zm3.467-2.352q0-.166-.032-.278-.027-.117-.101-.181-.07-.07-.187-.096-.117-.032-.299-.032H9.416v2.245h2.037q.166 0 .283-.026.117-.027.192-.091.075-.07.107-.181.037-.112.037-.283zM16.973 5.021h-2.517l-.517.838h-.934l2.112-3.36q.096-.155.23-.256.133-.102.384-.102.245 0 .378.102.134.101.23.256l2.101 3.36h-.939Zm-2.138-.624h1.76l-.88-1.434zM18.69 5.859V5.17h2.763q.219 0 .315-.059.096-.064.096-.25v-.198q0-.17-.096-.24-.096-.075-.31-.075h-1.733q-.304 0-.506-.053-.198-.059-.315-.17-.117-.118-.165-.289-.043-.176-.043-.41v-.182q0-.277.059-.474.058-.198.181-.315.123-.123.32-.176.197-.059.47-.059h1.13v.688H19.8q-.187 0-.277.075-.086.07-.086.288v.117q0 .171.08.246.08.069.278.069h1.701q.304 0 .512.053.213.048.347.16.133.112.192.288.058.176.058.422v.288q0 .256-.058.437-.059.176-.192.288-.134.112-.347.165-.208.054-.512.054zM26.59 5.859V4.408h-2.667v1.45h-.811V2.222h.81v1.483h2.667V2.221h.806V5.86z",
    style: {
      fill: "#ff0"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4d2186577ba8209c892c79564121133b.svg";
export { ForwardRef as ReactComponent };